"use client";

import type { ReactNode } from "react";

import type { Resource } from "i18next";
import { I18nextProvider } from "react-i18next";

import i18n from "@/shared/config/i18n/client";
import type { AppLanguage } from "@/shared/config/i18n/config";

type PublicI18nBoundaryProps = {
  readonly children: ReactNode;
  readonly locale: AppLanguage;
  readonly resources: Resource[string];
};

export function PublicI18nBoundary({ children, locale, resources }: PublicI18nBoundaryProps) {
  if (!i18n.exists("landing.hero.title1", { lng: locale })) {
    i18n.addResourceBundle(locale, "translation", resources.translation, true, true);
  }

  if (i18n.resolvedLanguage !== locale) {
    void i18n.changeLanguage(locale);
  }

  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
}
